import { httpCall } from '@common/util';
import AppConstants from '@config/appConstants';
import { getAuthHeaders } from '@utils/authManager.js';

export const fetchPropertyCountries = () =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: '/1.0/pl/countries',
  });

export const fetchMailingCountries = () =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: '/1.0/ma/countries',
  });

export const fetchStates = ({ country, q = '' }) =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/address/states?q=${encodeURIComponent(q)}&country=${encodeURIComponent(country)}`,
  });

export const fetchCountiesByState = ({ state, q = '' }) =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/address/counties?q=${encodeURIComponent(q)}&state=${encodeURIComponent(state)}`,
  });

export const fetchCitiesByCounty = ({ county, q = '' }) =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/cities?q=${encodeURIComponent(q)}&county=${encodeURIComponent(county)}`,
  });

export const lookupByZip = ({ zip, country }) =>
  httpCall({
    method: AppConstants.httpMethod.GET,
    headers: getAuthHeaders(),
    url: `/1.0/locations/zip?q=${encodeURIComponent(zip)}&c=${encodeURIComponent(country)}`,
  });
